import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../app/store";

export interface ParkingTypeState {
  totalRecords: number | null;
  data: [] | null;
  totalPages: number | null;
  currentPage: number | null;
}

const initialState: ParkingTypeState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
};

export const parkingTypeSlice = createSlice({
  name: "parkingType",
  initialState,
  reducers: {
    setParkingType: (state, action) => {
      state.data = action.payload;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalRecords = action.payload.totalRecords;
    },
    resetParkingType: (state) => {
      state = initialState;
    },
  },
});

export const { setParkingType, resetParkingType } = parkingTypeSlice.actions;

export const getParkingType = (state: RootState) => state.parkingTye.data;

export default parkingTypeSlice.reducer;
